/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiStandardCodeLookup.ts         *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-standard-code-lookup";

export class AutogenModelEdiStandardCodeLookup<RowType extends ModelRow> extends Endpoint<RowType, RowEdiStandardCodeLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiStandardCodeLookup extends ModelRow<RowEdiStandardCodeLookupFields> {
	constructor(values?: Partial<RowEdiStandardCodeLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiStandardCodeLookupFields {
	company_id: string;
	description: string;
	element_id: string;
	standard_code: string;
	version: string;
}

